export interface TakeoffRevisionListItem {
  _id: string;
  createdAt: number;
  revisionRootJobId?: string;
  revisionNumber?: number;
}

export function getTakeoffRevisionNumber(job: TakeoffRevisionListItem) {
  return job.revisionNumber ?? 1;
}

export function groupTakeoffJobsByRevision<T extends TakeoffRevisionListItem>(jobs: T[]) {
  const groupsByRootId = new Map<string, T[]>();
  for (const job of jobs) {
    const rootId = job.revisionRootJobId ?? job._id;
    const group = groupsByRootId.get(rootId) ?? [];
    group.push(job);
    groupsByRootId.set(rootId, group);
  }

  return Array.from(groupsByRootId.entries())
    .map(([rootId, groupJobs]) => {
      const jobsInRevisionOrder = groupJobs.sort(
        (left, right) =>
          getTakeoffRevisionNumber(left) - getTakeoffRevisionNumber(right) ||
          left.createdAt - right.createdAt
      );
      return {
        rootId,
        jobs: jobsInRevisionOrder,
        latestJob: jobsInRevisionOrder[jobsInRevisionOrder.length - 1],
        historyJobs: [...jobsInRevisionOrder.slice(0, -1)].reverse(),
        latestCreatedAt: Math.max(...groupJobs.map((job) => job.createdAt)),
      };
    })
    .sort((left, right) => right.latestCreatedAt - left.latestCreatedAt);
}
